const PENDING_PAYMENT = 'pending';
const APPROVED = 'approved';
const REJECTED = 'rejected';
const REQUEST_MONEY = 'REQUEST_MONEY';
const SAVE_MONEY = 'SAVE_MONEY';
const statusList = {
    PENDING_PAYMENT,
    APPROVED,
    REJECTED
}
const statusMapping = {
    pending: "PENDING_PAYMENT",
    rejected: "REJECTED",
    approved: "APPROVED",
}
const { formatText } = require('core/i18n').i18n;

const requestStatus = () => {
    return [
        {
            value: PENDING_PAYMENT,
            label: formatText(`openYoungHistoryView-openYoungHistoryView_${PENDING_PAYMENT}`)
        },
        {
            value: APPROVED,
            label: formatText(`openYoungHistoryView-openYoungHistoryView_${APPROVED}`)
        },
        {
            value: REJECTED,
            label: formatText(`openYoungHistoryView-openYoungHistoryView_${REJECTED}`)
        }
    ]
}

module.exports = {
    APPROVED,
    PENDING_PAYMENT,
    REJECTED,
    REQUEST_MONEY,
    requestStatus,
    SAVE_MONEY,
    statusList,
    statusMapping
};
